<script>
 
export default {
    name: "paymentCoa",

    data() {

        return {
            errors: [],
            coa:{},
             selectedClass: `bg-red-300 `,
            unselectedClass: `bg-gray-100 `,
            AddSelectedPayment:false,
            showpaymentmodal:false,
            
            coaid:0,
            tocheck:false,
            //  selectedCoaid: 0,
            //   selectedCoaName: '',
            selectedCoadetails: {
                 selectedCoaName: '',
                 selectedCoaid: 0,
            },
          
        };
    },

    props: {
        
       
        bankandcashcoas: {
            type: Array,
            required: true,
        }, showModal: {
            type: Boolean,
            required: true,
        },
    },

    watch: {
        'coa.categoryID'() {
            if(!this.coa.categoryID) {
                this.coa.category = ``;
                return;
            }
            
        },
    },

    methods: {

        
        
         selectedAccount(){
            this.AddSelectedPayment=true; 
           this.closeModal = false;
         
             this.$emit(`AccountSelected`, this.selectedCoadetails);
        },
       
        selectRow(user){
    this.selectedCoadetails.selectedCoaid = user;
    this.bankandcashcoas.forEach(coas => {
                    coas.check = false;
                    if(coas.coaid == this.selectedCoadetails.selectedCoaid ){
                         coas.check = true;
                         this.selectedCoadetails.selectedCoaName=coas.coaName;
                    }
            });
    //Do other things
}
    },
    components: {
            // "initiate-payment": () => import('./initiate-payment.vue'),
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/3 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-sm">COA</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap items-center">
             <div class="w-full overflow-auto mt-2">
        <table class="table table-hover">
            <thead class="bg-blue-500 text-xs text-white">
                <tr>
                     <th class="p-tiny w-0.5"> </th>
                 <th class="p-tiny">Account Name</th>
                </tr>
            </thead>
            <tbody class="bg-gray-100 text-xs">
                <tr v-for="(coa, idx) in bankandcashcoas" :key="idx"  @click="selectRow(coa.coaid) " :class="coa.coaid == selectedCoadetails.selectedCoaid ? selectedClass : unselectedClass">  
                      <td class="p-tiny w-0.5" >
                                         <input type="checkbox" v-model="coa.check"  >
                                      </td><td class="p-tiny"  >{{ coa.coaName }}   </td>
                    <!-- <td class="p-tiny">
                        <button
                            @click.prevent="coa.approve=true" 
                            class="btn-sm btn-info text-xs rounded">
                            <i class="fa fa-check"></i> Select</button>
                    </td> -->
                    <!-- <approve-cancel-form 
                        :payment="pendingPayment"
                        :showModal="pendingPayment.approve"
                        @closeModal="pendingPayment.approve = false"
                        @refresh="fetchPendingPayments" 
                    /> -->
                </tr>
            </tbody>
        </table>
    </div>
           
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded mr-6" 
            @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
        <button 
            @click.prevent="selectedAccount"
            class="btn-primary btn-sm text-xs rounded">
               <i class="fa fa-save"></i> Procced</button>
                <!-- <initiate-payment
            :bankandcashcoas="bankandcashcoas"
            :accountname="selectedCoaName"
            :accountid="selectedCoaid"
            :supplierlist="suppliers"
            :payModes="payModes"
                 :showModal2="showpaymentmodal" 
                @closeModal2="AddSelectedPayment = false"
                
            /> -->
      </template>
    </tail-modal>
</template>
